import { render, staticRenderFns } from "./Bloodoxygen.vue?vue&type=template&id=38b94741"
import script from "./Bloodoxygen.vue?vue&type=script&lang=js"
export * from "./Bloodoxygen.vue?vue&type=script&lang=js"
import style0 from "./Bloodoxygen.vue?vue&type=style&index=0&id=38b94741&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports